import type { RequestParams } from '@/shared/api';

export const APPLICATION_KEYS = {
  all: ['application'] as const,
  list: (params?: RequestParams) => [...APPLICATION_KEYS.all, 'list', params] as const,
};
